import * as React from 'react';
import { Menu, MenuItem, IconButton, Avatar, Typography, Box, Switch, Divider, ListItemText } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function LogoutMenu({ chromeStyle, onChangeChromeStyle }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { signout  } = useAuth();
  
  
  
  const dsNome = localStorage.getItem("nomeUsuario");
  const userInitial = dsNome ? dsNome.charAt(0) : "?";

   const navigate = useNavigate();
  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {

     signout();
     handleClose();
     navigate("/");

  };

  const handleToggleChromeStyle = () => {
    onChangeChromeStyle?.(chromeStyle === "white" ? "blue" : "white");
  };

  return (
    <div>
      <IconButton onClick={handleClick} color="inherit">
        <Avatar>{userInitial}</Avatar>
        <Typography style={{ marginLeft: 8 }}>{dsNome}</Typography>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ horizontal: 'left', vertical: 'bottom' , padding: 10}}>
        {onChangeChromeStyle && (
          <MenuItem onClick={handleToggleChromeStyle} style={{ width: 260, justifyContent: 'space-between', gap: 12 }}>
            <ListItemText primary="Tema clássico" secondary="Fundo branco no menu" />
            <Switch edge="end" size="small" checked={chromeStyle === "white"} />
          </MenuItem>
        )}
        {onChangeChromeStyle && <Divider />}
        <MenuItem onClick={handleLogout} style={{   width: 260, justifyContent: 'flex-start' }}>
          <ExitToAppIcon style={{ marginRight: 8 }} /> Sair
        </MenuItem>
      </Menu>
    </div>
  );
}